import { DepartmentSelect } from '../../shop/departmentSelect';
import { Gridwall } from '../../shop/gridWall';
import { Pdp } from '../../shop/pdp';
import { allExceptInvoiceOnly } from '../../util/rolePermissions';

const shopRoutes = [
  {
    path: '/shop/department-select',
    title: 'DepartmentSelect',
    component: DepartmentSelect,
    nav: false,
    exact: true,
    limitToRoles: allExceptInvoiceOnly
  },
  {
    path: '/shop/:accountId/dept/:departmentId/:type/',
    title: 'Gridwall',
    component: Gridwall,
    nav: false,
    exact: true,
    limitToRoles: allExceptInvoiceOnly,
    isShopping: true
  },
  {
    path: '/shop/:accountId/dept/:departmentId/:type/:productId',
    title: 'Pdp',
    component: Pdp,
    nav: false,
    exact: true,
    limitToRoles: allExceptInvoiceOnly,
    isShopping: true
  },
  {
    path: '/shop/:accountId/dept/:departmentId/:type/:productId/:styleId',
    title: 'Pdp',
    component: Pdp,
    nav: false,
    exact: true,
    limitToRoles: allExceptInvoiceOnly,
    isShopping: true
  }
];

export default shopRoutes;
